import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Analytics icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Analytics } from '@sravni/design-system-icons'
 *
 * <Analytics />
 * ```
 */
var Analytics = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Analytics", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m17.948 5.77-4.226 4.227a.832.832 0 0 1-1.178 0L10.76 8.213a.832.832 0 0 0-1.178 0l-4.967 4.966", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M17.948 17.378H2.052V2.622", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Analytics };
//# sourceMappingURL=Analytics.js.map
